var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"chart",attrs:{"id":"myChart"}}),_c('b-button',{on:{"click":_vm.resetZoom}},[_vm._v("Reset time range")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }